import { CardCvcElement } from '@stripe/react-stripe-js';
import styled from 'styled-components';

import { stripeInputStyles, TProps } from './stripeInputStyles';

export const StyledCVCElement = styled(CardCvcElement)<TProps>`
  ${stripeInputStyles}
`;
